module.exports = __webpack_public_path__ + "static/media/x-no-circle.7da40fc3.svg";